import { get, isEmpty } from 'lodash';
import { createSelector } from 'reselect';

export const getHasMoneyMarketEventMessage = (state) =>
  state.moneyMarketEvent.hasMoneyMarketMessage &&
  !isEmpty(state.moneyMarketEvent.message);

export const getMoneyMarketEventGlobalMessage = (state) =>
  get(state, 'moneyMarketEvent.message.globalMessageAttributes');

const getMoneyMarketReformMessages = (state) =>
  get(state, 'moneyMarketEvent.message.moneyMarketReformFundMessages');

export const getMoneyMarketReformFundMessages = createSelector(
  getHasMoneyMarketEventMessage,
  getMoneyMarketReformMessages,
  (hasMoneyMarketEventMessage, moneyMarketReformMessages) =>
    hasMoneyMarketEventMessage && moneyMarketReformMessages
      ? moneyMarketReformMessages
      : {}
);
